module.exports = __webpack_public_path__ + "media/customizations/hawaiian/back-bf03dd2e859b4e20a4c45df06c50391c.jpg";